import React from "react";
import line from "../images/line.svg";

function Divider() {
  return (
    <div className="line">
      <img src={line} alt="line" />
    </div>
  );
}

export default Divider;
